export default __webpack_public_path__ + "static/media/central_andes_2_9.2132c0f2.JPG";